var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { d: 'M6 12v7.234a24.48 24.48 0 0012 0V12H6zm0-2V8.25C6 4.809 8.675 2 12 2s6 2.809 6 6.25V10h1a1 1 0 011 1v9a1 1 0 01-.725.962 26.48 26.48 0 01-14.55 0A1 1 0 014 20v-9a1 1 0 011-1h1zm2 0h8V8.25C16 5.892 14.198 4 12 4S8 5.892 8 8.25V10zm4 4a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm2 1a1 1 0 01-1 1h-2a1 1 0 010-2h2a1 1 0 011 1z', role: 'presentation' })
  );
}

module.exports = function locked(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};